const data = {
    "Gender": "Gender",
    "Male": "Male",
    "Female": "Female",
    "Gender is required": "Gender is required",
    "Sold (male)": "Sold (male)",
    "Sold (female)": "Sold (female)",
    "Information found": "Information found",
    "Information not found": "Information not found",
    "Internal server error": "Internal server error",
    "Full name": "Full name",
    "Phone number": "Phone number",
    "Application ID": "Application ID",
    "Application date": "Application date",
    "Privilege category": "Category",
    "Validity period": "Validity period",
    "Loading": "Loading",
    "Privilege check": "Privilege check",
    "Check": "Check",
    "Checking": "Checking",
    "All privilege checks": "All privilege checks",
    "Date of birth": "Date of birth",
    "Checking all privileges. Please wait...": "Checking all privileges. Please wait...",
    "Total": "Total",
    "Found": "Found",
    "Errors": "Errors",
    "Debug response": "Debug response",
    "PINFL must contain 14 digits": "PINFL must contain 14 digits",
    "PINFL is required for a privilege ticket": "PINFL is required for a privilege ticket",
    "A companion requires exactly one primary privileged passenger in the order": "A companion requires exactly one primary privileged passenger in the order",
    "Only one companion is allowed for a primary privileged passenger": "Only one companion is allowed for a primary privileged passenger",
    "Enter date of birth in YYYY-MM-DD format": "Enter date of birth in YYYY-MM-DD format",
    "Privilege check could not be completed": "Privilege check could not be completed",
    "Not found": "Not found",
    "Response received": "Response received",
    "Records": "Records",
    "Partial": "Partial",
    "Error": "Error",
    "Chernobyl radiation illness": "Chernobyl radiation illness",
    "Nuclear radiation veteran": "Nuclear radiation veteran",
    "Elderly disabled needing care": "Elderly disabled needing care",
    "Accompanying person": "Accompanying person",
    "Student": "Student",
    "Disabled youth vocational training": "Disabled youth vocational training",
    "Social registry youth competition": "Social registry youth competition",

    "Sales": "Sales",
    "Cashier's workplace": "Cashier's workplace",
    "Ticket selling": "Ticket selling",
    "Tickets": "Tickets",
    "Booking": "Booking",
    "Purchase": "Purchase",
    "Book now": "Book now",
    "Flight will be closed through": "Flight will close in",
    "Ticket sales time for this trip is over": "Ticket sales for this trip have ended",
    "Flight info": "Trip information",
    "Places": "Seats",
    "Free": "Free",
    "Booked": "Booked",
    "Reserved": "Reserved",
    "Sold": "Sold",
    "Reserved seats": "Reserved seats",
    "Reserved seats become available in": "Reserved seats become available in",
    "First floor": "First floor",
    "Second floor": "Second floor",
    "Reservation fee": "Reservation fee",
    "Pre-sale fee": "Pre-sale fee",
    "sum": "UZS",
    "Trip": "Trip",
    "Passport data is required for international trips": "Passport data is required for international trips",
    "It is allowed to book more than 1 place for a cashier": "The cashier may book more than one seat",
    "Yes": "Yes",
    "No": "No",
    "Maximum one seat": "Maximum one seat",
    "Passenger personal data": "Passenger personal data",
    "Required": "Required",
    "Regular": "Regular",
    "FULL NAME": "Full name",
    "Passenger type": "Passenger type",
    "Services": "Services",
    "Bus station collection": "Bus station fee",
    "Amount": "Amount",
    "Total amount": "Total amount",
    "Passport details must be filled in and unique": "Passport details must be filled in and unique",
    "Enter a comment": "Enter a comment",
    "Select service type": "Select a service type",
    "With a child": "With a child",
    "Without a child": "Without a child",
    "Payment": "Payment",
    "Amount to pay": "Amount to pay",
    "Received": "Received",
    "Change due": "Change",
    "Payment type": "Payment type",
    "By card": "By card",
    "Cash": "Cash",
    "Pay": "Pay",
    "Pay with PIN pad": "Pay with PIN pad",
    "Close": "Close",
    "Personal data": "Personal data",
    "All fields must be filled in using Latin letters": "All fields must be filled in using Latin letters",
    "Passport series": "Passport series",
    "Citizenship": "Citizenship",
    "Select a country": "Select a country",
    "Place of residence": "Place of residence",
    "Save": "Save",
    "Child's personal data": "Child's personal data",
    "Child's passport series": "Child's passport series",
    "Consent of the other parent": "Consent of the other parent",
    "Cancel": "Cancel",
    "Seat booking": "Seat booking",
    "The seats you selected have already been booked by other passengers": "The seats you selected have already been booked by other passengers",
    "Seat number": "Seat number",
    "You have successfully booked a seat": "You have successfully booked a seat",
    "Your ID": "Your ID",
    "Passenger": "Passenger",
    "Place": "Seat",
    "This seat is being booked by another user": "This seat is being booked by another user",
    "User": "User",
    "User role": "User role",
    "Booking type": "Booking type",
    "Domestic": "Domestic",
    "International": "International",
    "Success": "Success",
    "Operation completed successfully! The customer paid": "Operation completed successfully! The customer paid:",
    "An unexpected error occurred.": "An unexpected error occurred.",
    "Data was not saved!": "Data was not saved!",
    "Error receiving data from the server!": "Error receiving data from the server!",
    "Unable to get DeviceId!": "Unable to get DeviceId!",
    "Z report opened successfully!": "Z report opened successfully!",
    "Error opening Z report!": "Error opening Z report!",
    "Unable to save the receipt on the server!": "Unable to save the receipt on the server!",
    "Error paying the receipt!": "Error paying the receipt!",
    "Only one seat can be selected!": "Only one seat can be selected!",
    "Passenger number": "Passenger number",
    "Full name is required": "Full name is required",
    "All passenger data is required for international trips": "All passenger data is required for international trips",
    "All passenger and child data is required for international trips": "All passenger and child data is required for international trips",
    "Full name must contain only Latin letters": "Full name must contain only Latin letters",
    "Passport details are invalid": "Passport details are invalid",
    "Passport details are required": "Passport details are required",
    "Child's full name must contain only Latin letters": "Child's full name must contain only Latin letters",
    "International ticket": "International ticket",
    "Domestic ticket": "Domestic ticket",
    "Bus station service": "Bus station service",
    "Driver": "Driver",
    "Cashier": "Cashier",
    "Conductor": "Conductor",
    "Privilege found": "Privilege found",
    "No privilege information found": "No privilege information found",
    "Last privilege ticket": "Last discounted ticket",
    "No privilege ticket history found": "No discounted ticket history found",
    "Ticket number": "Ticket number",
    "Ticket date": "Ticket date",
    "Route": "Route",
    "Ticket type": "Ticket type",
    "Ticket cost": "Ticket cost",
    "Paid amount": "Paid amount",
    "Passport number": "Passport number",
    "Privilege code": "Privilege code",
    "Discount percent": "Discount percent",
    "Trips per year": "Trips per year",
    "Discount note": "Discount note",
    "Privilege used": "Privilege used",
    "Privilege already used": "This privilege has already been used",
    "Transport type": "Transport type",
    "Ticket issue date": "Ticket issue date",
    "Route type": "Route type",
    "Ticket series and number": "Ticket series and number",
    "Full fare amount": "Full fare amount",
    "Subsidy amount": "Subsidy amount",
    "Disability group": "Disability group",
    "Disability reason": "Disability reason",
    "Registration date": "Registration date",
    "Valid from": "Valid from",
    "Valid until": "Valid until",
    "Document number": "Document number",
    "Certificate number": "Certificate number",
    "Organization": "Organization",
    "Course": "Course",
    "Record": "Record",
    "Privilege service unavailable": "The check service is unavailable. Please try again later",
    "No privilege checks enabled": "No privilege checks are currently enabled",
    "Privilege check incomplete": "The check is incomplete. Eligibility has not been confirmed",
    "Vocational training status unconfirmed": "This response does not confirm vocational training status",
    "No additional details available": "No additional details available",
    "Education type": "Education type",
    "Education form": "Education form",
    "Education status": "Education status",
    "Speciality": "Speciality",
    "Start year": "Start year",
    "Survey ID": "Survey ID",
    "Poverty level": "Social category",
    "Registry status": "Registry status",
    "Chernobyl radiation illness": "Persons affected by radiation sickness after the Chernobyl nuclear accident",
    "Nuclear radiation veteran": "Disabled pensioners who served at nuclear test sites and radiation facilities",
    "Elderly disabled needing care": "Single elderly people and persons with disabilities who need care",
    "Accompanying person": "Accompanying person for single elderly people and persons with disabilities",
    "Student": "Students",
    "Disabled youth vocational training": "Vocational training for youth with disabilities",
    "Social registry youth competition": "Members aged 14–30 of families in the social registry",
    "Social protection registry": "Social protection registry",
    "World War II participants": "World War II participants"
};

export default data;
